<template>
  <CustomTitleBar title="设置" />
  <div class="page-content">
    <van-cell-group>
      <van-cell title="聊天设置" is-link />
      <div class="br-16"></div>
      <van-cell title="安全设置" is-link />
      <van-cell title="隐私设置" is-link />
      <div class="br-16"></div>
      <van-cell title="通知设置" is-link />
      <div class="br-16"></div>
      <van-cell title="注销账号" is-link />
    </van-cell-group>

    <div class="logout-button">
      <van-button round type="danger" @click="handleLogout">
        退出登录
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { showDialog } from 'vant';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
const router = useRouter();
const store = useStore();

const handleLogout = () => {
  showDialog({
    title: '提示',
    message: '确定要退出登录吗？',
    showCancelButton: true,
  }).then(() => {
    // 清除用户登录信息
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('currentNavbar');
    store.dispatch('user/logout');
  }).catch(() => {
    // 取消退出
  });
};

onMounted(() => {
  // 可以在这里添加初始化逻辑
});
</script>

<style lang="scss" scoped>
.page-content {
  padding: 56px 0 0;

  :deep(.van-cell-group) {
    overflow: hidden;

    .van-cell {
      height: 56px;
      border-bottom: 1px solid #f7f7f7;

      .van-cell__title {
        font-size: 16px;
      }

    }
  }

  .logout-button {
    margin-top: 56px;
    padding: 0 24px;

    :deep(.van-button) {
      width: 100%;
      height: 56px;
      font-size: 16px;
      background-color: #FA5151;
      border: none;
    }
  }
}
</style>
